import React, { useState } from "react";
import CommonLayout from "../../layouts/CommonLayout";

const FrequentQuestionPage = () => {
    const [activeTab, setActiveTab] = useState('모임');

    // 질문 데이터를 객체로 관리
    const questionsData = {
        모임: [
            {
                question: "모임은 어떻게 만들 수 있나요?",
                answer: "모임 목록 화면의 + 버튼을 눌러서 모임을 만들 수 있습니다. 모임 생성 시 쌀 500알이 차감됩니다."
            },
        ],
        쌀: [
            {
                question: "쌀은 어떻게 충전하나요?",
                answer: "마이페이지 > 쌀 충전에서 구매하실 수 있습니다."
            },
            {
                question: "쌀 사용 내역은 어디서 확인할 수 있나요?",
                answer: "마이페이지 > 쌀 지갑에서 모든 쌀 사용 내역을 확인할 수 있습니다."
            },
        ],
        기타: [
            {
                question: "내 위치를 바꾸고 싶어요.",
                answer: "마이페이지 > 내 위치 설정 에서 바꿀 수 있습니다."
            },
            {
                question: "계정을 삭제할 수 있나요?",
                answer: "설정 > 계정 정보 > 탈퇴하기 에서 탈퇴할 수 있습니다."
            },
            {
                question: "앱 사용 중 문제가 발생하면 어떻게 하나요?",
                answer: "마이페이지 > 고객센터 에 있는 이메일로 문의주시면 최대한 빠르게 도와드리겠습니다."
            }
        ]
    };

    // 질문 렌더링 함수
    const renderQuestions = (questions) => (
        <div className="space-y-4">
            {questions.map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-4 border border-gray-200">
                    <h3 className="font-semibold text-gray-900 mb-2">Q. {item.question}</h3>
                    <p className="text-gray-700 text-sm">{item.answer}</p>
                </div>
            ))}
        </div>
    );

    return (
        <CommonLayout title="자주 하는 질문">
            <div className="p-4">
                {/* 탭 버튼 */}
                <div className="flex bg-gray-100 rounded-lg p-1 mb-6">
                    {['모임', '쌀', '기타'].map((tab) => (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                                activeTab === tab
                                    ? 'bg-white text-amber-600 shadow-sm'
                                    : 'text-gray-600'
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* 질문 목록 */}
                {renderQuestions(questionsData[activeTab])}
            </div>
        </CommonLayout>
    );
};

export default FrequentQuestionPage;
